import { reactive, effectScope, readonly, computed, nextTick } from 'vue';
import version from '../../utils/version';
import { useCookie } from '../../hooks/useCookie';
const sLazyImage = useStorage('supportLazyImage', '')
if (!sLazyImage.value) {
  let testImg = document.createElement('img');
  if ('loading' in testImg) {
    sLazyImage.value = 'true'
  } else {
    sLazyImage.value = 'false'
  }
}
let scope;
let initialized = false;
// ssr，动态加载，HMR中，模块可能会在更新时重新加载，导致状态管理器重新初始化
// 初始全局变量:有一些是必须要做的东西，比如打开的平台
import { UAParser } from 'ua-parser-js';
const parser = new UAParser()
const { getCookie } = useCookie()

const useGlobalState = () => {
  if (!initialized) {
    scope = effectScope();
    scope.run(() => {
      const state = reactive({
        isBind: false,
        // 玩家是否绑定角色
        scan_token: '',
        utm_source:'gw',
        extra:'gw',
        firstUrl: '',
        // 页面进来的最开始url，就是要用这个来注册微信端内的分享
      });

      const setBind = (value) => {
        state.isBind = value;
      };

      const setScanToken = (value) => {
        state.scan_token = value
      }

      const setUtmSource=(value) => {
        state.utm_source = value
      }

      const setExtra=(value) => {
        state.extra = value
      }

      const setFirstUrl=(value) => {
        console.log('设置基本url',value)
        state.firstUrl=value
      }
      // 将响应式状态和方法挂载到作用域上
      scope.state = state;
      scope.setBind = setBind
      scope.setScanToken = setScanToken
      scope.setUtmSource = setUtmSource
      scope.setExtra = setExtra
      scope.setFirstUrl = setFirstUrl
      const device = parser.getDevice()
      const os = parser.getOS()
      const result=parser.getResult()
      const ua = reactive({
        type: device.type,
        vendor: device.vendor,
        model: device.model,
        name: os.name,
        version: os.version,
        isMobile:result.device.type === 'mobile',
      })
      scope.ua = ua

      // 将版本号挂载到全局
      scope.version = version

      //判断玩家是否登录的标记
      const cookie = ref(getCookie('TXH5_TX3_HUILIU_TOKEN'))
      const isLogin = computed(() => {
        if (cookie.value || state.scan_token != '' || Object.keys(initData).length>0 && Object.keys(initData.role_info).length>0) {
          return true
        } else {
          return false
        }
      })

      scope.isLogin = isLogin


      // 检查是否支持lazyLoad图片加载
      const supportLazyImage = ref(sLazyImage.value)
      scope.supportLazyImage = supportLazyImage

      //==============每次活动有关
      var initData = reactive({})
      scope.initData = initData

      const setInitData = () => {
        Object.keys(initData).forEach(key => {
         delete initData[key];
        });
        console.log('initData 初始化',initData)
      }
      scope.setInitData = setInitData

      const updateInitData = (data) => {
        Object.assign(initData, data);
      }
      scope.updateInitData = updateInitData
    });
  }
  initialized = true
  return {
    state: readonly(scope.state),
    ua: readonly(scope.ua),
    version: scope.version,
    isLogin: readonly(scope.isLogin),
    setBind: scope.setBind,
    setScanToken: scope.setScanToken,
    supportLazyImage: readonly(scope.supportLazyImage),
    initData: readonly(scope.initData),
    updateInitData: scope.updateInitData,
    setInitData: scope.setInitData,
    setUtmSource: scope.setUtmSource,
    setExtra: scope.setExtra,
    setFirstUrl: scope.setFirstUrl,
  };
};

export { useGlobalState };
// 感觉就是写起来比较麻烦
